import { CommonStateType, PayloadType } from "@/common/types";
import Types from "../types";
import { getThemePreference } from "@/utils/common.util";

const commonInitialState: CommonStateType = {
  loader: false,
  theme: getThemePreference(),
};

export const commonReducer = (
  state = commonInitialState,
  action: PayloadType
) => {
  switch (action.type) {
    case Types.SET_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case Types.SET_THEME:
      return {
        ...state,
        theme: action.payload,
      };
    default:
      return state;
  }
};
